import { disposableValue } from '../../../common/utils/disposable-value';

export const SEARCH_SESSION_ID: import('../../../common/utils/disposable-value').DisposableValue<string> =
	disposableValue<string>();
